// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user?.avatar?.url?.thumbnail}
      alt={user?.avatar?.file_name}
      color={user?.avatar?.url?.thumbnail ? 'default' : createAvatar(user?.first_name).color}
      {...other}
    >
      {createAvatar(user?.first_name).name}
    </Avatar>
  );
}
